import { Slide } from '@widgets/Gallery/types'
import { parseUrlFn, ScribbleCollectionItem, SizeDef } from './types'

const formatItem = ({ Url, Data, Meta }: ScribbleCollectionItem): Slide => {
  const cMeta = Meta ?? {}
  const { url, width } = Data
    ? Data.alternateSizes
        .filter((i: SizeDef) => i.width < 1400)
        .sort((a, b) => b.width - a.width)[0]
    : { url: undefined, width: 1 }
  const match = (url ? url : Url).match(new RegExp('.*scribblelive.com(.*)'))

  const [_, urlSegment] = match || []
  return {
    kind: ['widget', 'image'],
    image: {
      src: `https://bucket-files.scribblelive.com${urlSegment}`,
      alt: cMeta.caption,
      width,
      height: 0,
    },
    caption: cMeta.caption || '',
  }
}

const parseUrl: parseUrlFn = (url: string) => {
  const match = url.match(new RegExp('.*/collection/(.*)/template.*token=(.*)'))
  const [_, collectionId, token] = match || []
  return { galleryId: collectionId, token }
}

export { formatItem, parseUrl }
